import { useEffect, useMemo } from "react";
import useStore from "../lib/store";
import { BASE_CURRENCY, DISPLAY_CURRENCIES } from "../lib/consts";

export default function useCurrencies() {
    const rentals = useStore((state) => state.rentals);
    const exchangeRates = useStore((state) => state.exchangeRates);
    const setExchangeRates = useStore((state) => state.setExchangeRates);

    // BASE_CURRENCY is excluded from the `to` list — Frankfurter rejects requests where
    // the base currency also appears in `to`, returning an error without CORS headers.
    const foreignCurrencies = useMemo(
        () => new Set([
            ...rentals
                .filter(r => r.price_currency && r.price_currency !== BASE_CURRENCY)
                .map(r => r.price_currency as string),
            ...DISPLAY_CURRENCIES.map(c => c.value).filter(c => c !== BASE_CURRENCY),
        ]),
        [rentals],
    );

    useEffect(() => {
        if (foreignCurrencies.size === 0) return;
        const missing = [...foreignCurrencies].filter(c => !(c in exchangeRates));
        if (missing.length === 0) return;

        fetch(`https://api.frankfurter.dev/v1/latest?from=${BASE_CURRENCY}&to=${missing.join(',')}`)
            .then(res => res.json())
            .then(data => {
                if (!data.rates) {
                    console.error('Unexpected exchange rate response:', data);
                    return;
                }
                setExchangeRates({ ...exchangeRates, ...data.rates, [BASE_CURRENCY]: 1 });
            })
            .catch(err => console.error('Failed to fetch exchange rates:', err));
    }, [exchangeRates, foreignCurrencies, setExchangeRates]);

    return exchangeRates;
}
